
import { Name } from "../prm/name";
import { OptionMenu } from "../prm/option-menu";
import { DtcClearingMembers } from "./dtc_clearing_members";

const gen_menu_items = () => {
  const names = [];
  Object.keys(DtcClearingMembers).forEach(firm_id => {
    if (DtcClearingMembers[firm_id].label) {
      names.push(new Name(firm_id, DtcClearingMembers[firm_id].label));
    }
  });
  return names;
};

const MENU_ITEMS = gen_menu_items();

class DTCClearingMembersMenu extends OptionMenu {
  constructor(name) {
    super(name, MENU_ITEMS);
  }
}

const DTC_ID_TO_LABEL = dtc_id => {
  const menu = MENU_ITEMS.find(name => name.id === dtc_id);
  if (!menu) {
    return null;
  }
  return menu.label;
}

export { DTCClearingMembersMenu, DTC_ID_TO_LABEL};
